import styled from 'styled-components';

export const HappinessImage = styled.img`
  width: 100%;
  padding: 0 10px 12px;
  height: auto;
  @media (max-width: 720px) {
    display: ${(props) => (props.showOnMobile ? 'none' : '')};
  }
`;
